import { debounce } from './utils';


function handleMobileMenu() {
  const breakpoint = window.matchMedia('(max-width: 1279px)');
  const btnHamburger = document.querySelector('#btn-hamburger');
  const mainMenuMobile = document.querySelector('#navbar-mobile');
  const openSubMenuButtons = document.querySelectorAll('.mobile-main-menu .mega-menu-item.has-children > .mega-menu-item-link[level="1"]');
  const subMenus = document.querySelectorAll('.mobile-main-menu .mega-menu__submenu');
  const menuBackButtons = document.querySelectorAll('.mobile-main-menu .submenu-back-button button');
  const btnClose = document.querySelector('#btn-close-menu');
  const searchBlock = document.querySelector('.header-search-block');
  const btnToggleSearch = document.querySelector('.btn-open-search-box');

  if (btnHamburger && mainMenuMobile) {
    btnHamburger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (searchBlock) {
        searchBlock.classList.remove('active');
      }
      mainMenuMobile.classList.add('active');
      document.body.classList.add('menu-open');
    });
  }

  if (btnToggleSearch && searchBlock) {
    btnToggleSearch.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      searchBlock.classList.add('active');
      document.body.classList.add('menu-open');

      const searchInput = searchBlock.querySelector('input');
      searchInput.focus();
    });
  }

  function reset() {
    if (mainMenuMobile) {
      mainMenuMobile.classList.remove('active');
    }

    if (subMenus.length > 0) {
      subMenus.forEach((submenu) => {
        submenu.classList.remove('active');
        const parentMenu = submenu.closest('.mega-menu-item')?.parentElement;

        if (parentMenu) {
          parentMenu.style.height = '';
        }
      });
    }

    if (searchBlock) {
      searchBlock.classList.remove('active');
    }

    if (btnToggleSearch) {
      btnToggleSearch.classList.remove('active');
    }

    document.body.classList.remove('menu-open');
  }

  btnClose.addEventListener('click', () => {
    reset();
  });

  if (breakpoint?.addEventListener) {
    breakpoint.addEventListener('change', () => {
      reset();
    });
  } else {
    breakpoint.addListener(reset);
  }

  if (openSubMenuButtons.length > 0) {
    openSubMenuButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const parentItem = button.closest(`li.mega-menu-item`);
        const activeSubmenu = parentItem.querySelector(`.mega-menu__submenu`);

        if (activeSubmenu) {
          activeSubmenu.classList.add('active');
          parentItem.parentElement.style.height = 0;
        }
      });
    });
  }

  if (menuBackButtons.length > 0) {
    menuBackButtons.forEach((backButton) => {
      backButton.addEventListener('click', (e) => {
        e.preventDefault();
        const activeSubmenu = backButton.closest('.mega-menu__submenu');
        const parentMenuItem = activeSubmenu.closest('.mega-menu-item');
        if (activeSubmenu) {
          parentMenuItem.parentElement.style.height = 'auto';
          activeSubmenu.classList.remove('active');
        }
      });
    });
  }
}

function handleDesktopMenu() {
  const breakpoint = window.matchMedia('(min-width: 1280px)');
    const mainMenu = document.body.classList.contains('rdn') ? document.querySelector('.acha-main-menu') : document.querySelector('#block-acha-megamenublock');
  const levelOneMenuItems = document.querySelectorAll('.main-header-desktop .mega-menu-item.has-children[level="1"] > a');
  const subMenuItems = document.querySelectorAll('.main-header-desktop .mega-menu__submenu-wrapper');
  const arrowTip = document.querySelector('.main-header-desktop .acha-main-navigation .arrow-tip');
  const darkOverlay = document.querySelector('.dark-overlay');
  const btnToggleSearch = document.querySelector('.btn-toggle-search-desktop');
  const btnCloseSearch = document.querySelector('#btn-close-search-block');
  const searchBlock = document.querySelector('.header-search-block');
  const btnCloseMenuDesktop = document.querySelector('.btn-close-menu-desktop');
  const mobileNav = document.querySelector('#navbar-mobile');


  if (btnToggleSearch && searchBlock && btnCloseSearch && mainMenu) {

    btnToggleSearch.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      resetDesktopMenu();
      searchBlock.classList.add('active');
      document.body.classList.add('menu-open');

      const searchInput = searchBlock.querySelector('input');
      searchInput.focus();
    });

    btnCloseSearch.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      searchBlock.classList.remove('active');
      document.body.classList.remove('menu-open');
    });
  }

  if (!levelOneMenuItems.length > 0) return;

  levelOneMenuItems.forEach((menuItem) => {
    menuItem.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();

      if (menuItem.classList.contains('active')) {
        resetDesktopMenu();
      } else {
        openSubMenu(menuItem);
      }
    });
  });

  function openSubMenu(menuItem) {
    const subMenu = menuItem.nextElementSibling;
    if (subMenu) {
      document.body.classList.add('menu-open');
      levelOneMenuItems.forEach((item) => item.classList.remove('active'));
      subMenuItems.forEach((item) => item.classList.remove('active'));
      subMenu.classList.add('active');
      menuItem.classList.add('active');

      if (searchBlock && btnToggleSearch) {
        searchBlock.classList.remove('active');
        btnToggleSearch.classList.remove('active');
      }
    }
  }
  function resetDesktopMenu() {
    document.body.classList.remove('menu-open');
    levelOneMenuItems.forEach((item) => item.classList.remove('active'));
    subMenuItems.forEach((item) => item.classList.remove('active'));
    if (searchBlock) {
      searchBlock.classList.remove('active');
    }

    if (mobileNav) {
      mobileNav.classList.remove('active');
    }
  }


    btnCloseMenuDesktop?.addEventListener('click', (e) => {
      e.stopPropagation();
      resetDesktopMenu();
    });


  if (breakpoint?.addEventListener) {
    breakpoint.addEventListener('change', () => {
      resetDesktopMenu();
    });
  } else {
    breakpoint.addListener(resetDesktopMenu);
  }

  darkOverlay.addEventListener('click', () => {
    resetDesktopMenu();
  });


  window.addEventListener('keyup', (e) => {
    if (e.key == 'Escape') {
      resetDesktopMenu();
    }
  });

  function updateArrowPositionOnResize() {
    const activeItem = document.querySelector('.main-header-desktop .mega-menu-item.has-children[level="1"] > a.active');
    if (activeItem) {
      arrowTip.style.left = `${activeItem.offsetLeft + activeItem.getBoundingClientRect().width / 2 - arrowTip.getBoundingClientRect().width / 2}px`;
    }
  }

  window.addEventListener('resize', debounce(updateArrowPositionOnResize, 200));
}

function createSubmenuLayout() {
  const subMenus = document.querySelectorAll('.main-header-desktop .mega-menu__submenu[level="2"]');
  const subMenusBackButtons = document.querySelectorAll('.main-header-desktop .submenu-back-button');

  if (!subMenus.length > 0) return;

  if (subMenusBackButtons.length > 0) {
    subMenusBackButtons.forEach((btn) => btn.remove());
  }

  function updateLayout() {
    subMenus.forEach((submenu) => {
      const menuItems = submenu.querySelectorAll('.mega-menu-item[level="2"]');

      let columnOneHeight = 0;
      let columnTwoHeight = 0;

      for (let i = 0; i < Math.floor(menuItems.length / 2) + 1; i++) {
        if (menuItems[i]) { // Check if menuItems[i] is defined
          columnOneHeight += Math.ceil(menuItems[i].getBoundingClientRect().height); // display main-menu.js:271 Uncaught TypeError: Cannot read properties of undefined (reading 'getBoundingClientRect')
          menuItems[i].classList.add('column-1');

          if (i === Math.floor(menuItems.length / 2)) {
            menuItems[i].style.paddingBottom = '0';
          }
        }
      }

      for (let j = Math.floor(menuItems.length / 2) + 1; j < menuItems.length; j++) {
        if (menuItems[j]) { // Check if menuItems[j] is defined
          columnTwoHeight += Math.ceil(menuItems[j].getBoundingClientRect().height);
          menuItems[j].classList.add('column-2');
        }
      }

      if (columnOneHeight + columnTwoHeight > 300) {
        const subMenuHeight = Math.max(columnOneHeight, columnTwoHeight) + 10;
        submenu.style.height = `${subMenuHeight}px`;
        submenu.classList.add('two-columns');
      } else {
        submenu.classList.add('one-column');
      }
    });
  }

  updateLayout();

  window.addEventListener('resize', debounce(updateLayout, 500));
}



window.addEventListener('DOMContentLoaded', () => {
  handleMobileMenu();
  handleDesktopMenu();
  createSubmenuLayout();
});
